module.exports = __webpack_public_path__ + "images/help/icon-twr45@2x-52afa5fbd4422b56e8b1f11713c64ac2.png";